import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2Card } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import * as _ from "lodash";
import { createRef, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import { getDaylightProfile } from "../../../../../../core/api/services/asset/light-profile/daylight-profile.service";
import { getOperationMode } from "../../../../../../core/api/services/asset/light-profile/timer-profile.service";
// import { getToken } from "../../../../../../core/auth/auth.service";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import { NotificationTypeEnum } from "../../../../../../core/enums/notification-type-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import {
  convertTo24Hour,
  removeSecondsFromTime,
} from "../../../../../../shared/helpers/convert-time-format";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import TitleComponent from "../../../../../../shared/title/title.component";
import {
  enableOrDisableDaylightProfile,
  getDaysOfWeek,
  postDaylightProfile,
  sendGetCommandToDms,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";
import AssetActionFormComponent from "../common/asset-action-form.component";

const OldDaylightProfileComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();

  const user = getUserInfo();

  const [PageNumber] = useState<number>(1);
  // const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  // const [isDelete, setIsDelete] = useState<boolean>(false);
  const [SortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection] = useState<any>("desc");
  const [searchValue] = useState("");
  // const [isEnable, setIsEnable] = useState<boolean>(false);
  const pageSize = 10;
  const [submittedFormData, setSubmittedFormData] = useState<any>({});
  const [actionOptions, setActionOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startTime: "",
    endTime: "",
    // repeatAction: 30,
    zoneID: "",
    // photosensor: "",
    dimThreshold: "",
    brightThreshold: "",
    dimActionId: "",
    brightActionId: "",
    isEnabled: false,
    dimLevel: "",
    brightLevel: "",
  });

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  // const connectSocket = () => {
  //   const daylightProfileClient = new W3CWebSocket(
  //     `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push?name=asset-daylightprofile`
  //   );

  //   daylightProfileClient.onopen = () => {
  //     console.log("WebSocket Daylight Profile Client Connected");

  //     setSocketStatus("open");
  //     daylightProfileClient.send(
  //       JSON.stringify({ token: new Date().getUTCMilliseconds() })
  //     );
  //     setRetryCount(0);
  //   };

  //   daylightProfileClient.onmessage = (message: any) => {
  //     const data = JSON.parse(`${message.data}`);
  //     const user = getUserInfo();
  //     if (
  //       user.email.toLowerCase() === data.NotificationIdentifier.toLowerCase()
  //     ) {
  //       toast.success("Acknowledgement Received", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnFocusLoss: true,
  //         draggable: true,
  //         pauseOnHover: true,
  //       });
  //     }

  //     refetchDaylightProfile();
  //   };

  //   daylightProfileClient.onclose = (event: any) => {
  //     console.log("WebSocket Daylight Profile Closed", event);

  //     setSocketStatus("closed");
  //     setIsCallRetry((prev: boolean) => !prev);
  //   };

  //   setSocket(daylightProfileClient);
  // };

  // useEffect(() => {
  //   setRetryCount((current: number) => current + 1);

  //   if (socketStatus == "initial") {
  //     connectSocket();
  //   } else if (socketStatus == "closed") {
  //     if (retryCount < WEBSOCKET_MAX_RETRY_COUNT) {
  //       setTimeout(() => {
  //         console.log(
  //           `Daylight Profile Retry Attempts ${retryCount}/${WEBSOCKET_MAX_RETRY_COUNT}}`
  //         );

  //         connectSocket();
  //       }, 5000);
  //     } else {
  //       console.log(
  //         `Maximum retry attempts reached for Daylight Profile WebSocket`
  //       );
  //     }
  //   }

  //   return () => {
  //     if (socket && socket.readyState === socket.OPEN) {
  //       socket.close();
  //       console.log("Daylight Profile Client socket closed");
  //     }
  //   };
  // }, [socketStatus, isCallRetry]);

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const {
    data: daylightProfiles,
    refetch: refetchDaylightProfile,
    isFetching,
  } = useQuery({
    queryKey: [
      "getDaylightProfile",
      pageSize,
      PageNumber,
      SortBy,
      SortDirection,
      id,
      searchValue,
    ],
    queryFn: () =>
      getDaylightProfile(
        pageSize,
        PageNumber,
        SortBy,
        SortDirection,
        id,
        searchValue
      ),
    // enabled: onRefetchEnabled
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.DayLightProfile) {
      showToaster(socketRealTimeUpdateData);
      void refetchDaylightProfile();
      // setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const { data: operationModes } = useQuery({
    queryKey: ["getOperationMode"],
    queryFn: () => getOperationMode(),
  });

  useEffect(() => {
    const modes = operationModes?.data?.map((mode: any) => ({
      value: mode?.id,
      label: mode?.name,
    }));

    setActionOptions(modes);
  }, [operationModes]);

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
  });

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  useEffect(() => {
    if (!daylightProfiles || !Object.keys(daylightProfiles).length) return;

    setInitialValues({
      profileName: daylightProfiles?.profileName,
      startTime: removeSecondsFromTime(daylightProfiles?.startTime),
      endTime: removeSecondsFromTime(daylightProfiles?.endTime),
      zoneID: daylightProfiles?.zoneID,
      // photosensor: daylightProfiles?.photosensor,
      dimThreshold: daylightProfiles?.dimThreshold,
      brightThreshold: daylightProfiles?.brightThreshold,
      dimActionId: daylightProfiles?.dimActionId,
      brightActionId: daylightProfiles?.brightActionId,
      // repeatAction: daylightProfiles?.repeatAction,
      isEnabled: daylightProfiles?.isEnabled,
      dimLevel: daylightProfiles?.dimLevel || 0,
      brightLevel: daylightProfiles?.brightLevel || 0,
    });
  }, [daylightProfiles]);

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });

    dispatch(getDaysOfWeek());
  }, [dispatch]);

  const lightProfileSocketData = useSelector((state: any) => {
    return state.asset.lightProfileSocketData;
  });

  useEffect(() => {
    if (
      lightProfileSocketData?.Type == NotificationTypeEnum.DAY_LIGHT_PROFILE
    ) {
      void refetchDaylightProfile();
    }
  }, [lightProfileSocketData]);

  const formConfig = {
    controls: [
      {
        label: "Daylight Profile",
        isGrid: true,
        isShadow: false,
        gridClass: "profile-grid",
        controlGroup: [
          {
            name: "startTime",
            label: "Start Time",
            placeholder: "Start Time",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "endTime",
            label: "End Time",
            placeholder: "End Time",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },

          {
            name: "dimThreshold",
            label: "Dim Threshold (Lux)",
            placeholder: "e.g: 200",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "dimActionId",
            label: "Dim Action",
            placeholder: "Select Dim Action",
            type: "select",
            options: actionOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "brightThreshold",
            label: "Bright Threshold (Lux)",
            placeholder: "e.g: 400",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "brightActionId",
            label: "Bright Action",
            placeholder: "Select Bright Action",
            type: "select",
            options: actionOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "dimLevel",
            label: "Dim Level (%)",
            placeholder: "e.g: 12",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "brightLevel",
            label: "Bright Level (%)",
            placeholder: "e.g: 80",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "zoneID",
            label: "Group",
            placeholder: "Select Group",
            type: "select",
            options: groupOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
            gridFullWidth: true,
          },
          /*           {
            name: "repeatAction",
            label: "Repeat Action",
            placeholder: "Repeat Action",
            type: "number",
            readOnly: isDetails,
            disabled: isDetails,
          }, */
          /*           {
            name: "photosensor",
            label: "Photo Sensor",
            placeholder: "Search Photo sensor",
            type: "chips",
            dispatchableApi: getAssetsByGateway,
            required: false,
            readOnly: isDetails,
            disabled: isDetails,
            gridFullWidth: true,
          }, */
          {
            name: "isEnabled",
            label: "Profile Control",
            placeholder: "",
            type: "switch",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
        ],
      },
    ],
  };

  const handleCloseModal = () => {
    // setIsEdit(false);
    setIsDetails(false);
    // setIsDelete(false);
  };

  const [isOTPModalOpen, setIsOTPModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const handleCloseOtpModal = () => {
    setIsOTPModalOpen(false);
  };

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const {
        startTime,
        endTime,
        // repeatAction,
        zoneID,
        // photosensor,
        dimThreshold,
        brightThreshold,
        dimActionId,
        brightActionId,
        dimLevel,
        brightLevel,
      } = form.values;

      if (
        !startTime ||
        !endTime ||
        !dimThreshold ||
        !brightThreshold ||
        !dimActionId ||
        !brightActionId ||
        // repeatAction < 0 ||
        !zoneID ||
        dimThreshold < 0 ||
        dimThreshold > 10000 ||
        !dimLevel ||
        dimLevel?.length > 100 ||
        !brightLevel ||
        brightLevel?.length > 100
      ) {
        return;
      }

      // setIsOtpModalOpen(true);
      // setIsEnable(true);
      const data = {
        ...form.values,
        startTime: convertTo24Hour(form.values.startTime),
        endTime: convertTo24Hour(form.values.endTime),
        dimActionId: Number.parseInt(form.values.dimActionId),
        brightActionId: Number.parseInt(form.values.brightActionId),
        // photosensor: form.values.photosensor,
        isEnabled: form.values.isEnabled || false,
        assetCode: id,
        dimAction: "",
        brightAction: "",
        profileControl: "",
        dimLevel: Number.parseInt(form.values.dimLevel),
        brightLevel: Number.parseInt(form.values.brightLevel),
      };
      setInitialValues(data);
      setSubmittedFormData(data);

      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOTPModalOpen(true);
      } else {
        onSubmitMfaOtp(data);
      }
    }

    handleCloseModal();
  };

  const onSubmitMfaOtp = (data?: any) => {
    dispatch(
      postDaylightProfile({ body: data ? data : submittedFormData })
    ).then((res: any) => {
      dispatch(
        enableOrDisableDaylightProfile({
          id: res?.payload?.data?.id,
        })
      );

      handleCloseOtpModal();

      void refetchDaylightProfile();
    });

    dispatch(setOtpIsValidation(false));
  };

  const validation = yup.object().shape({
    startTime: yup.string().required("Start Time is required"),
    endTime: yup.string().required("End Time is required"),
    // repeatAction: yup.number().min(0, "Should be a positive number"),
    zoneID: yup.number().min(1, "Zone is required"),
    dimThreshold: yup
      .string()
      .required("Dim Threshold is required")
      .min(0, "Dim Threshold must be at least 0")
      .max(10000, "Dim Threshold must be at most 10,000"),
    brightThreshold: yup.string().required("Bright Threshold is required"),
    dimActionId: yup.string().required("Dim Action is required"),
    brightActionId: yup.string().required("Bright Action is required"),
    dimLevel: yup
      .number()
      .required("Dim Level is required")
      .min(0, "Dim Level must be at least 0")
      .max(100, "Dim Level must be at most 100"),
    brightLevel: yup
      .number()
      .required("Bright Level is required")
      .min(0, "Bright Level must be at least 0")
      .max(100, "Bright Level must be at most 100"),
  });

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const handleRefresh = () => {
    setIsRefreshing(true);

    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.DayLightProfile),
      })
    )
      .then(() => {
        refetchDaylightProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Daylight Profile | Asset</title>
      </Helmet>
      <div>
        <div>
          <div className="my-5">
            <TitleComponent title="Configure Daylight Profile" />
          </div>
          <div className="my-3">
            <B2Card className="card-bg">
              <B2Card.Header className="fs-5 fw-bold header-bg">
                <div className="d-flex form-header dashboard-generic-actions align-items-center">
                  <p className="m-0 flex-grow-1">Profile Information</p>
                  <button
                    type="button"
                    className="ms-2 cursor-pointer fs-6 fw-bold bg-transparent border-0 p-0"
                    onClick={handleRefresh}
                  >
                    <FontAwesomeIcon
                      icon={faRotateRight}
                      className="fs-7 me-2"
                    />
                    Refresh
                  </button>
                </div>
              </B2Card.Header>

              <B2Card.Body>
                {isRefreshing || isFetching ? (
                  <div
                    className="d-flex justify-content-center"
                    style={{ minHeight: "400px" }}
                  >
                    <Spinner
                      animation="border"
                      variant="primary"
                      className="mt-5"
                    />
                  </div>
                ) : (
                  <div>
                    <AssetActionFormComponent
                      formRef={formRef}
                      validation={validation}
                      initialValues={initialValues}
                      formConfig={formConfig}
                      moduleName={"DayLight Profile"}
                      actionName={"Edit-DayLight Profile"}
                    />
                    <div style={{ marginLeft: ".2rem" }}>
                      <HasPermission
                        moduleName="DayLight Profile"
                        actionName="Edit-DayLight Profile"
                        isRoute={false}
                      >
                        <B2Button onClick={() => onSubmit()}>Save</B2Button>
                      </HasPermission>
                    </div>
                  </div>
                )}
              </B2Card.Body>
            </B2Card>
          </div>
        </div>

        {/* modals */}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default OldDaylightProfileComponent;
